export default "__VITE_ASSET__DMHdhpbx__"